"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FaqHero() {
  const {
    ref: mainRef,
    isVisible: mainVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="9357" id="faqhero" className="relative bg-background text-foreground overflow-hidden border-b border-border ![margin:1px_0px_1px_0px]">
      {}
      <div className="absolute top-8 right-8 hidden lg:block">
        
      </div>

      <div className="mx-auto max-w-[1440px] px-6 py-8 md:![padding:50px_24px_96px_24px]">
        <div ref={mainRef} className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col relative" style={{
          opacity: mainVisible ? 1 : 0,
          transform: mainVisible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 600ms cubic-bezier(0.16, 1, 0.3, 1), transform 600ms cubic-bezier(0.16, 1, 0.3, 1)"
        }}>
            {}
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-[1px] bg-primary" />
              <span className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-primary">FAQ</span>
            </div>

            <h1 className="font-sans font-bold text-foreground leading-[1.1] tracking-[-0.04em] mb-8 text-3xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl break-words">
              Precision <br />
              <span className="text-muted-foreground/20">Engineering</span> <br />
              Defined.
            </h1>

            <p className="max-w-xl text-muted-foreground font-sans text-lg md:text-xl leading-relaxed mb-12">
              Find detailed specifications, maintenance guides, and answers to common questions regarding our premium architectural metal systems.
            </p>

            {}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mb-12 border-l border-border pl-8 relative">
              {}
              <div className="absolute -left-[2.5px] top-0 w-[5px] h-[5px] bg-primary" />
              
              <div className="flex flex-col gap-1">
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">01</span>
                <span className="font-sans font-semibold text-sm uppercase tracking-wider">Material Specs</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">02</span>
                <span className="font-sans font-semibold text-sm uppercase tracking-wider">Installation</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">03</span>
                <span className="font-sans font-semibold text-sm uppercase tracking-wider">Warranty</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full sm:w-auto">
              <Button asChild className="w-full sm:w-auto min-h-[48px] bg-primary text-primary-foreground rounded-sm font-mono uppercase tracking-[0.2em] text-xs px-8 py-6 h-auto hover:bg-primary/90 transition-all duration-300 shadow-lg">
                <Link to="/ContactPage">Request QUOTE<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-4" aria-hidden="true" data-ast-id="f:/src/pages/FAQ/sections/FaqHero.tsx|sig:r623bl" data-ast-start="3807" data-ast-end="3845"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
              <Button variant="outline" asChild className="w-full sm:w-auto min-h-[48px] border-border rounded-sm font-mono uppercase tracking-[0.2em] text-xs px-8 py-6 h-auto hover:bg-accent transition-all duration-300">
                
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative" style={{
          opacity: mainVisible ? 1 : 0,
          transition: "opacity 800ms cubic-bezier(0.16, 1, 0.3, 1)",
          transitionDelay: "200ms"
        }}>
            <div className="relative group">
              {}
              <div className="absolute -inset-4 border border-border pointer-events-none transition-colors duration-500 group-hover:border-primary/30" />
              
              <div className="relative aspect-[4/5] overflow-hidden bg-muted rounded-sm">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/architectural_cladding_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/architectural_cladding_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/architectural_cladding_detail.png-wvc-sizes" alt="Close up of architectural metal cladding precision" className="w-full h-full object-cover transition-transform duration-700 scale-105 group-hover:scale-110" loading="lazy" decoding="async" />
                
                {}
                <div className="absolute bottom-0 left-0 right-0 bg-background/90 backdrop-blur-sm p-6 border-t border-border">
                  <div className="flex justify-between items-end">
                    <div>
                      
                      <h3 className="font-sans font-bold text-lg uppercase tracking-tight">ACM PANEL&nbsp;</h3>
                    </div>
                    <div className="flex items-center gap-2 text-muted-foreground">
                      
                      
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute -right-12 top-1/2 -translate-y-1/2 rotate-90 hidden xl:block">
                <span className="font-mono text-[10px] uppercase tracking-[0.5em] text-muted-foreground/30 whitespace-nowrap">
                  ARCHITECTURAL_PRECISION_EXTERIORS
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}